import React, { useEffect, useState } from "react";
import axios from "axios";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";

const LabelManagement = () => {
  const [labels, setLabels] = useState([]);
  const [name, setName] = useState("");
  const [color, setColor] = useState("#000000");
  const [editingLabel, setEditingLabel] = useState(null);
  
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    fetchLabels();
  }, []);

  const fetchLabels = async () => {
    try {
      const response = await axios.get(`${appConstants.API_ROOT_URL}get-labels`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLabels(response.data.data);
    } catch (error) {
      console.error("Error fetching labels", error);
    }
  };

  const handleAddOrUpdateLabel = async (e) => {
    e.preventDefault();
    try {
      const payload = { name, color };
      if (editingLabel) {
        payload.id = editingLabel.id;
      }
      
      const url = editingLabel
        ? `${appConstants.API_ROOT_URL}update-label`
        : `${appConstants.API_ROOT_URL}create-label`;

      await axios.post(url, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setName("");
      setColor("#000000");
      setEditingLabel(null);
      fetchLabels();
    } catch (error) {
      console.error("Error saving label", error);
    }
  };

  const handleEdit = (label) => {
    setEditingLabel(label);
    setName(label.name);
    setColor(label.color);
  };

  const handleCancelEdit = () => {
    setEditingLabel(null);
    setName("");
    setColor("#000000");
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this label?")) return;
    try {
      await axios.post(
        `${appConstants.API_ROOT_URL}delete-label`,
        { id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      fetchLabels();
    } catch (error) {
      console.error("Error deleting label", error);
    }
  };

  return (
    <Layout>
      <h2>Label Management</h2>
      <form onSubmit={handleAddOrUpdateLabel} className="mb-3 p-3 border rounded" style={{ backgroundColor: "#f3f3f3", maxWidth: "400px" }}>
        <div className="mb-2">
          <label className="form-label">Label Name</label>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="mb-2">
          <label className="form-label">Color</label>
          <input
            type="color"
            className="form-control form-control-color"
            style={{ width: "60px", height: "40px" }}
            value={color}
            onChange={(e) => setColor(e.target.value)}
            required
          />
        </div>
        <div>
          <button type="submit" className="btn btn-primary me-2">
            {editingLabel ? "Update Label" : "Add Label"}
          </button>
          {editingLabel && (
            <button type="button" className="btn btn-secondary" onClick={handleCancelEdit}>
              Cancel
            </button>
          )}
        </div>
      </form>
      <ul className="list-group" style={{ maxWidth: "400px" }}>
        {labels.map((label) => (
          <li key={label.id} className="list-group-item d-flex justify-content-between align-items-center">
          <span className="d-flex align-items-center">
            <span 
              className="badge me-2 d-inline-block" 
              style={{ 
                backgroundColor: label.color, 
                width: "20px", 
                height: "20px", 
                borderRadius: "20%", 
                lineHeight: "20px"
              }}>
            </span>
            {label.name}
          </span>
          <div>
            <button className="btn btn-sm btn-warning me-2" onClick={() => handleEdit(label)}>
              Edit
            </button>
            <button className="btn btn-sm btn-danger" onClick={() => handleDelete(label.id)}>
              Delete
            </button>
          </div>
        </li>
        
        ))}
      </ul>
    </Layout>
  );
};

export default LabelManagement;
